export const WRITE_GOOGLE_REVIEW_LINK =
  "https://search.google.com/local/writereview?placeid=ChIJ-XnU1NJ3QQ0RYae79y7-hJE"

export const INSTAGRAM_LINK = "https://www.instagram.com/blessing_torrelodones"

export const FB_LINK = "https://www.facebook.com/blessingtorrelodones"

export const WHATSAPP_LINK = "https://wa.me/34664605015"
